import React, { FC } from 'react';

import * as ST from '@r1-frontend/ui-react/components/controls/Toggle/styled';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

interface IProps {
    textsValues: { leftText: string, rightText: string },
    isDisabled?: boolean,
    colorTab?: string,
    onChangeCallback: (activeTab: string) => void,
    activeTab: string,
    fontSize?: FONTS,
    isDifferentColorText?: boolean,
}

const Toggle: FC<IProps> = ({
    textsValues,
    isDisabled = false,
    colorTab = COLORS.ButtonPrimary,
    onChangeCallback,
    activeTab,
    fontSize,
    isDifferentColorText = true,
    ...args
}) => {
    const translateData = { max: 100, min: 0 };
    const { leftText, rightText } = textsValues;
    const isRightTabActive = activeTab === rightText;

    const onClickHandler = () => {
        const activeText = isRightTabActive ? leftText : rightText;
        onChangeCallback(activeText);
    };

    return (
        <ST.Container isDisabled={isDisabled} data-test={'toggle-container'} fontSize={fontSize} {...args}>
            <ST.TabLeft
                onClick={onClickHandler}
            >
                <ST.LayoutLeft
                    translateValue={isRightTabActive ? translateData.max : translateData.min}
                    colorTab={!isDisabled ? colorTab : COLORS.GRAY_LIGHT}
                    data-test={'left-tab'}
                />
                <ST.Text
                    isActive={!isRightTabActive}
                    data-test={'left-text'}
                    isDifferentColorText={isDifferentColorText}
                >
                    {leftText}
                </ST.Text>
            </ST.TabLeft>
            <ST.TabRight
                onClick={onClickHandler}
                data-test={'right-container'}
            >
                <ST.LayoutRight
                    translateValue={isRightTabActive ? translateData.max : translateData.min}
                    colorTab={!isDisabled ? colorTab : COLORS.GRAY_LIGHT}
                    data-test={'right-tab'}
                />
                <ST.Text
                    isActive={isRightTabActive}
                    data-test={'right-text'}
                    isDifferentColorText={isDifferentColorText}
                >
                    {rightText}
                </ST.Text>
            </ST.TabRight>
        </ST.Container>
    );
};

export default Toggle;
